(() => {
  const linkSelector = '[data-dv-load-more-link]';

  document.addEventListener('click', async (event) => {
    const link = event.target.closest(linkSelector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const grid = document.getElementById('product-grid');
    if (!grid || link.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    const wrapper = link.closest('[data-dv-load-more]');
    const strings = wrapper ? wrapper.dataset : {};
    const status = document.querySelector('[data-dv-load-more-status]');
    const label = link.querySelector('[data-dv-load-more-label]');
    const spinner = link.querySelector('.dv-load-more__spinner');
    link.setAttribute('aria-disabled', 'true');
    link.classList.add('loading');
    if (label) label.textContent = strings.labelLoading || 'Carregando…';
    spinner?.classList.remove('hidden');
    if (status) status.textContent = strings.statusLoading || 'Carregando mais produtos.';

    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('section_id', grid.dataset.id);
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = parsed.getElementById('product-grid');
      if (!nextGrid) throw new Error('Product grid missing from response');

      const items = [...nextGrid.children];
      items.forEach((item) => grid.append(item));

      const currentPagination = link.closest('.dv-pagination');
      const nextPagination = parsed.querySelector('.dv-pagination');
      if (nextPagination) {
        currentPagination.replaceWith(nextPagination);
      } else {
        currentPagination.remove();
      }

      if (typeof window.initializeScrollAnimationTrigger === 'function') {
        window.initializeScrollAnimationTrigger();
      }

      let announcement;
      if (items.length === 1) {
        announcement = strings.addedOne || '1 produto adicionado.';
      } else {
        const template = strings.addedMany || '__count__ produtos adicionados.';
        announcement = template.replace('__count__', items.length);
      }
      const nextStatus = document.querySelector('[data-dv-load-more-status]');
      if (nextStatus) nextStatus.textContent = announcement;
    } catch (error) {
      console.error('Unable to load more products', error);
      link.removeAttribute('aria-disabled');
      link.classList.remove('loading');
      if (label) label.textContent = strings.labelRetry || 'Tentar novamente';
      spinner?.classList.add('hidden');
      if (status) status.textContent = strings.statusError || 'Não foi possível carregar mais produtos. Tente novamente.';
    }
  });
})();
